const doc = [({"zh_tw":({"adminConstantHotelWaitingListStatus":({"notified":"通知", "waiting":"等待職位空缺"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;